

export const MediaBaseURL="https://www.saray.vip/media/"
// export const MediaBaseURL="http://127.0.0.1:8000/media/"

export const MediaBaseURL2="https://www.saray.vip/media/"

export function hasChanged(oldObj, newObj, extions_key = []) {
    // 如果两个对象引用相同，直接返回 false
    if (oldObj === newObj) return false;

    // 如果其中一个为 null 或不是对象，直接比较值
    if (typeof oldObj !== 'object' || oldObj === null || typeof newObj !== 'object' || newObj === null) {
        return oldObj !== newObj;
    }

    // 获取新旧对象的键
    const oldKeys = Object.keys(oldObj);
    const newKeys = Object.keys(newObj);

    // 如果键的数量不同，说明发生了变化
    if (oldKeys.length !== newKeys.length) return true;

    // 遍历键，递归比较每个属性
    for (const key of oldKeys) {
        if (extions_key.indexOf(key)!==-1) continue;
        
        if (!newKeys.includes(key)) return true; // 如果新对象没有该键，说明发生了变化
        if (hasChanged(oldObj[key], newObj[key],extions_key)) return true; // 递归比较嵌套属性
    }

    return false;
}